<script setup>
import { useLayouts } from '@layouts'
import { config } from '@layouts/config'
import { can } from '@layouts/plugins/casl'
import { getComputedNavLinkToProp, isNavLinkActive } from '@layouts/utils'
import { useAdminEventStore } from "@/modules/admin/events/adminEventStore"

const props = defineProps({
  item: {
    type: null,
    required: true,
  },
})

const adminEventStore = useAdminEventStore()

const { width: windowWidth } = useWindowSize()
const { isVerticalNavMini, dynamicI18nProps } = useLayouts()
const hideTitleAndBadge = isVerticalNavMini(windowWidth)

const activeEventTitle = computed(() => {
  if(!adminEventStore.selectedEvent) return null

  return `(#${adminEventStore.selectedEvent.Id})`
})
</script>

<template>
  <li
    v-if="can(item.action, item.subject)"
    class="nav-link"
    :class="{ disabled: item.disable }"
  >
    <Component
      :is="item.to ? 'RouterLink' : 'a'"
      v-bind="getComputedNavLinkToProp(item)"
      :class="{ 'router-link-active router-link-exact-active': isNavLinkActive(item, $router) }"
    >
      <Component
        :is="config.app.iconRenderer || 'div'"
        v-bind="item.icon || config.verticalNav.defaultNavItemIconProps"
        class="nav-item-icon"
      />
      <TransitionGroup name="transition-slide-x">
        <!-- 👉 Title -->
        <Component
          :is="config.app.enableI18n ? 'i18n-t' : 'span'"
          v-show="!hideTitleAndBadge"
          key="title"
          class="nav-item-title"
        >
          {{ item.title }}
        </Component>

        <!-- 👉 Badge -->

        <span
          v-if="item.badgeContent && item.badgeContent.value"
          v-show="!hideTitleAndBadge"
          class="nav-item-badge"
          :class="item.badgeClass"
        >
          {{ item.badgeContent.value }}
        </span>
      </TransitionGroup>
    </Component>
  </li>
</template>

<style lang="scss">
.layout-vertical-nav {
  .nav-link a {
    display: flex;
    align-items: center;
  }
}
</style>
